/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sociaal_Emotioneel_Thema_Api_Errors_Minimum_Three_Sociaalemotioneeldoelen_Required2Inputs */

const nl_sociaal_emotioneel_thema_api_errors_minimum_three_sociaalemotioneeldoelen_required2 = /** @type {(inputs: Sociaal_Emotioneel_Thema_Api_Errors_Minimum_Three_Sociaalemotioneeldoelen_Required2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er moet minimaal één sociaalEmotioneelDoel worden geselecteerd`)
};

/**

* @param {Sociaal_Emotioneel_Thema_Api_Errors_Minimum_Three_Sociaalemotioneeldoelen_Required2Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const sociaal_emotioneel_thema_api_errors_minimum_three_sociaalemotioneeldoelen_required2 = /** @type {((inputs?: Sociaal_Emotioneel_Thema_Api_Errors_Minimum_Three_Sociaalemotioneeldoelen_Required2Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sociaal_Emotioneel_Thema_Api_Errors_Minimum_Three_Sociaalemotioneeldoelen_Required2Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_sociaal_emotioneel_thema_api_errors_minimum_three_sociaalemotioneeldoelen_required2(inputs)
});
export { sociaal_emotioneel_thema_api_errors_minimum_three_sociaalemotioneeldoelen_required2 as "sociaal_emotioneel_thema.api_errors.minimum_three_sociaalEmotioneelDoelen_required" }